import ViewerFactory from './Factory';

module.exports = {
  ViewerFactory
}
